// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Tabs } from '@shared/ui-kit/components/tabs';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import styles from './section-tabs.module.css';
import { useBankUploadSectionTabs } from './use-bank-upload-section-tabs';

export const BankUploadSectionTabs = defineComponent({
  displayName: 'BankUploadSectionTabs',
  useSetup: useBankUploadSectionTabs,
  View: ({ tabs, activeTab, onSelectSection }) => (
    <div className={styles['section-tabs']} data-testid="bank-upload-section-tabs">
      <Tabs.Root
        controlled
        defaultValue={activeTab}
        baseId="bank-upload-section-tabs"
      >
        <Tabs.Scrollable>
          <Tabs.List data-scrollable>
            {tabs.map(tab => (
              <Tabs.Trigger
                key={tab.section}
                value={tab.section}
                onClick={() => onSelectSection(tab.section)}
                data-testid={`bank-upload-section-tab-${tab.section}`}
              >
                <Translation i18nKey={tab.labelKey} ns="aggregator" />
              </Tabs.Trigger>
            ))}
          </Tabs.List>
        </Tabs.Scrollable>
      </Tabs.Root>
    </div>
  ),
});
